module.exports = __webpack_public_path__ + "img/smales-logo.3b5dc2d4.png";